module.exports = __webpack_public_path__ + "img/arrows-up-down-left-right.9c8d1c5c.svg";